var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs_box"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,class:{ active_tab: _vm.active === item.name },on:{"click":function($event){return _vm.handleTab(item.name)}}},[_vm._v(" "+_vm._s(item.tab)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }